module.exports = __webpack_public_path__ + "img/HU24719018.476db059.png";